import React, { useEffect, useState } from "react";
import { withRouter, useLocation } from "react-router-dom";
import { isSafari } from "react-device-detect";
import { connect, useDispatch } from "react-redux";
import { Auth, Hub } from "aws-amplify";
import { compose } from "redux";
import cx from "classnames";
import Socket from "socket";
import moment from "moment";
import _ from "lodash";
import GameNotFoundModal from "shared/components/gameNotFoundModal";
import Header from "../components/Header";
import useWindowDimensions from "../helpers/getWindowDimensions";
import Alert from "shared/components/alert";
import * as gameAction from "redux/game/action";
import * as loaderAction from "redux/loader/action";
import * as challengesAction from "redux/challenges/action";
import * as sbsAction from "redux/sbs/action";

import { on_sign_in } from "shared/helpers/onSignIn";
import { get_route_from_game_code } from "shared/helpers/get_route_from_game_code";
import HelpModal from "shared/components/HelpModal";

const Layout = (props) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const setSession = _.get(props, "setSession");
  const mobile_app = _.get(props, "gameReducer.mobile_app");
  const user_challenges = _.get(props, "challengesReducer.user_challenges");
  const how_to_play = _.get(props, "gameReducer.how_to_play");
  const sliceGameCode = _.get(props, "gameReducer.sliceGameCode");
  const gameName = _.get(props, "gameReducer.gameName");
  const roomId = _.get(props, "gameReducer.roomObj.id");
  const game_state = _.get(props, "gameReducer.roomObj.game_state");
  const users = _.get(props, "gameReducer.roomObj.users");
  const background_mobile = _.get(game_state, "background_mobile");
  const currentUser = _.get(props, "gameReducer.currentUser", null);
  const sessionObj = _.get(props, "gameReducer.sessionObj", null);
  const show_leave_game = _.get(props, "gameReducer.show_leave_game", false);
  const drop_down_help = _.get(props, "gameReducer.drop_down_help", false);
  const help_url = _.get(
    props,
    "paramsReducer.paramsObj.app.help_url",
    "https://gameapart-config.s3.amazonaws.com/common/general_help.html"
  );
  const [htmlContent, setHtmlContent] = useState("");

  const handle_help_click = () => {
    fetch(help_url)
      .then((response) => {
        return response.text();
      })
      .then((html) => {
        let content = html.split("<body>")[1].split("</body>")[0];
        setHtmlContent(content);
      })
      .catch((err) => {});
  };

  const handleHelpButtonClick = () => {
    dispatch(gameAction.set_drop_down_help(false));
  };

  useEffect(() => {
    handle_help_click();
  }, []);
  useEffect(() => {
    return Socket.addListener(
      "session-leave",
      handle_session_leave,
      log_on_error
    );
  }, []);
  const handle_end_game = (res) => {
    props.set_ttl_lie("");
    props.set_ttl_truths(["", ""]);
  };

  const end_game_error = (err) => {
    console.log("err: ", err);
  };
  useEffect(() => {
    return Socket.addListener("end-game", handle_end_game, end_game_error);
  }, []);

  useEffect(() => {
    window.addEventListener("message", handle_challenge_pop);
    return () => {
      window.removeEventListener("message", handle_challenge_pop);
    };
  }, []);

  const handle_challenge_pop = (e) => {
    const action = e.data.action;

    if (action === "challenge-pop") {
      let pathname = props.history.location.pathname;
      if (
        pathname.includes("my_entries") ||
        pathname.includes("team_leaderboard")
      ) {
        pathname = pathname.split("/");
        pathname.pop();
        pathname = pathname.join("/");
        props.history.replace(pathname);
      } else if (pathname.includes("challenges")) {
        const message = {
          action: "pop-challenges"
        };
        window.parent.postMessage(message, "*");
      } else {
        props.history.replace("/challenges");
      }
    }
  };

  const handle_session_leave = (res) => {
    if (res && res.message) {
      Alert(200, res.message);
      props.history.replace("/");
      setSession({});
    }
  };

  useEffect(() => {
    return Socket.addListener(
      "player-rejoin",
      on_player_rejoin_success,
      on_player_rejoin_error
    );
  }, []);

  useEffect(() => {
    return Socket.addListener(
      "challenge-entry",
      handle_challenge_entry,
      challenge_entry_error
    );
  }, [user_challenges]);

  useEffect(() => {
    return Socket.addListener(
      "session-rejoin",
      on_session_rejoin_success,
      on_session_rejoin_error
    );
  }, []);

  const handle_challenge_entry = (res) => {
    if (res && res.challenge_details && res.challenge_data) {
      let challenges = user_challenges;
      challenges = challenges.filter(
        (item) => item.challenge_id !== res.challenge_details.challenge_id
      );
      props.set_challenge_entries(res.challenge_data.data);
      challenges.push(res.challenge_details);
      props.set_user_challenges(
        challenges.sort(
          (a, b) =>
            moment(a.end_date, "MM/DD/YYYY") - moment(b.end_date, "MM/DD/YYYY")
        )
      );
      props.setIsLoading(false);
    }
  };
  const challenge_entry_error = () => {
    props.setIsLoading(false);
  };

  useEffect(() => {
    window.branch.init(
      "key_live_ddQZA5RPj07v525mmuaiOkijzuh2BTjo",
      function (err, data) {
        if (!_.isEmpty(data?.data_parsed) && data?.data_parsed.join_code) {
          props.setBranchJoincode(data?.data_parsed.join_code);
        }
      }
    );
  }, []);

  const on_player_rejoin_success = (data) => {
    if (data?.action == "player-rejoin") {
      const game_code = data?.room?.game_code;
      props.history.replace(get_route_from_game_code(game_code));
    }
    props.setIsLoading(false);
  };

  const on_session_rejoin_success = (data) => {
    props.setIsLoading(false);
  };

  const on_player_rejoin_error = (err) => {
    props.endGame();
    props.show_leave_game(true);
    props.setIsLoading(false);
  };

  const on_session_rejoin_error = (err) => {
    props.setSession({});
    props.show_leave_game(true);
    props.setIsLoading(false);
  };

  const log_on_error = () => {};

  useEffect(() => {
    if (show_leave_game === true) {
      if (
        Object.keys(sessionObj).length > 0 &&
        sessionObj?.session_id &&
        sessionObj?.valid
      ) {
        props.history.replace("/lobby");
      } else {
        props.history.replace("/");
      }
      props.show_leave_game(false);
    }
  }, [show_leave_game]);

  function toggle_how_to_play() {
    if (mobile_app) {
      const message = {
        action: "toggle-how-to-play"
      };
      window.parent.postMessage(message, "*");
    } else {
      props.how_to_play(!how_to_play);
    }
  }

  useEffect(() => {
    window.addEventListener("message", (e) => {
      const action = e.data.action;
      const value = e.data.value;
      if (action === "toggle-how-to-play") {
        props.how_to_play(value);
      }
    });
  }, []);

  const { height, width } = useWindowDimensions();

  const handle_leave_game = () => {
    const current_player_details = users?.find(
      (user) => user.user_id === currentUser.userId
    );
    // props.setIsLoading(true);
    const data = {
      action: "leave-room",
      roomId: roomId || "",
      playerId: current_player_details?.player_id || ""
    };
    Socket.sendMessage(data);
    props.endGame();
    setSession({});
    props.history.replace("/");
  };

  const handle_leave_session = () => {
    const data = {
      action: "session-leave",
      sessionId: sessionObj?.session_id,
      teamCode: sessionObj?.id,
      userId: currentUser?.userId
    };
    Socket.sendMessage(data);
    props.endGame();
    setSession({});
    props.history.replace("/");
  };

  const handleLogout = async () => {
    await Auth.signOut();
  };

  const hubListen = () => {
    Hub.listen("auth", async ({ payload: { event, data } }) => {
      switch (event) {
        case "signIn":
          const sub_id =
            data.signInUserSession.idToken.payload["cognito:username"];
          await on_sign_in(sub_id, props.history, null);
          break;
        case "oAuthSignOut":
        case "signOut":
          Alert(200, "You have successfully signed out");
          sessionStorage.clear();
          localStorage.clear();
          props.endGame();
          props.setCurrentUser({});
          props.setIsLoading(false);
          setSession({});
          props.history.replace("/signin");
          break;
        default:
      }
    });
  };

  useEffect(() => {
    hubListen();
  }, []);

  const handleModalButtonClick = () => {
    props.endGame();
    window.open(sliceGameCode);
    props.setSliceGameCode("");
  };

  const ltGlobalBackground = {
    background: `url(${background_mobile}) no-repeat`,
    backgroundSize: "cover",
    backgroundPosition: "center center"
  };

  return (
    <div
      className={`main-layout ${
        location.pathname.includes("challenge") ? "challenges" : ""
      } ${gameName === "VB" ? "VB" : ""}`}
      style={
        isSafari
          ? { position: "fixed", height: height, width: width }
          : { height: height, width: width }
      }
    >
      {!mobile_app &&
        !location.pathname.includes("signin") &&    !location.pathname.includes("invite_teammates") &&
        !location.pathname.includes("password_reset") && (
          <Header
            gameName={gameName}
            history={props.history}
            onLogout={handleLogout}
            handle_leave_game={handle_leave_game}
            toggle_how_to_play={toggle_how_to_play}
            handle_leave_session={handle_leave_session}
            handle_help_click={handle_help_click}
          />
        )}
      <main
        style={background_mobile ? { ...ltGlobalBackground } : {}}
        className={cx(
          `main-body ${
            location.pathname !== "/lobby" && gameName !== "" ? gameName : ""
          } ${ location.pathname == "/invite_teammates"?"invite-body":""} ` ,
          {
            mobile_app: mobile_app,
            signin:
              props.location.pathname === "/signin" ||
              props.location.pathname === "/password_reset"
          }
        )}
      >
        {/* <h4 style={{ position: "absolute", color: "black", opacity: 0.2 }}>
          {width}x{height}
        </h4> */}
        {drop_down_help && (
          <HelpModal
            btn_text="OK"
            content={htmlContent}
            onPress={handleHelpButtonClick}
          />
        )}

        {sliceGameCode !== "" && (
          <GameNotFoundModal
            btn_text="Get the App"
            onClose={() => props.setSliceGameCode("")}
            onPress={handleModalButtonClick}
            text="You joined an activity that requires the heyLIME Mobile App!"
          />
        )}
        {props.children}
      </main>
    </div>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
  challengesReducer: state.challengesReducer
});

const mapDispatchToProps = (dispatch) => {
  return {
    endGame: (data) => dispatch(gameAction.endGame(data)),
    setSession: (data) => dispatch(gameAction.setSession(data)),
    setSliceGameCode: (data) => dispatch(gameAction.setSliceGameCode(data)),
    how_to_play: (data) => dispatch(gameAction.how_to_play(data)),
    setCurrentUser: (data) => dispatch(gameAction.setCurrentUser(data)),
    show_leave_game: (data) => dispatch(gameAction.show_leave_game(data)),
    setBranchJoincode: (data) => dispatch(gameAction.setBranchJoincode(data)),
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
    set_challenge_details: (data) =>
      dispatch(challengesAction.set_challenge_details(data)),
    set_user_challenges: (data) =>
      dispatch(challengesAction.set_user_challenges(data)),
    set_challenge_entries: (data) =>
      dispatch(challengesAction.set_challenge_entries(data)),
    set_ttl_truths: (data) => dispatch(sbsAction.set_ttl_truths(data)),
    set_ttl_lie: (data) => dispatch(sbsAction.set_ttl_lie(data))
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(Layout);
